export default __webpack_public_path__ + "static/media/rawtuna.34fec838.PNG";